<template>
  <div class="info-overlay-body">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-0 mr-3">{{ shortCaseNumber }}</h4>
      <Icon icon="times" class="close-button" @click.native="$emit('close')" />
    </div>
    <div class="ml-2" v-if="!caseSpecimens.length && loadingText.text">
      <span :class="loadingText.class">{{ loadingText.text }}</span>
    </div>
    <div class="ml-1">
      <div v-for="specimen of caseSpecimens" v-bind:key="specimen.id" class="mb-1">
        <h5 v-if="caseSpecimens.length > 1" class="mb-0">
          <b>{{ specimen.specimenOrder }}:</b>
        </h5>
        <div class="ml-2">
          <div v-html="getDisplayText(specimen, 'Macro', 'resultsMacros', 'displayName')" />
          <div v-html="getDisplayText(specimen, 'Tx', 'specimenTransactions', 'cptCode')" />
          <div v-html="getDisplayText(specimen, 'ICD', 'icdCodes', 'displayCode')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SpecimensApi } from "../services";
import Icon from "./common/Icon.vue";
import { shortenAccessionNumber } from "@/modules/helpers";
import eventBus, { REFRESH_INFO_OVERLAY } from "@/modules/eventBus";

export default {
  components: { Icon },
  props: ["caseDetails"],
  data() {
    return {
      caseSpecimens: [],
      loadingText: { text: "", class: "" }
    };
  },
  computed: {
    ...mapState({
      reportCaseId: state => state.report.caseId,
      specimens: state => state.accessionStore.specimens
    }),
    shortCaseNumber() {
      return shortenAccessionNumber(this.caseDetails?.caseNumber) || "";
    }
  },
  mounted() {
    this.refreshCaseSpecimens();
    eventBus.$on(REFRESH_INFO_OVERLAY, this.refreshCaseSpecimens);
  },
  beforeDestroy() {
    eventBus.$off(REFRESH_INFO_OVERLAY);
  },
  methods: {
    getDisplayText(specimen, displayName, field, displayExpr) {
      const boldDisplayName = `<b>${displayName}:</b> `;
      let valueText = "<i>none</i>";
      if (specimen[field]?.length) {
        valueText = specimen[field]
          .map(e => e[displayExpr] + (field === "specimenTransactions" ? ` (${e.quantity})` : ""))
          .join(", ");
      }
      return boldDisplayName + valueText;
    },
    refreshCaseSpecimens() {
      this.loadingText = { text: "Loading specimens...", class: "" };
      SpecimensApi.getSpecimen(this.reportCaseId)
        .then(res => {
          this.loadingText = { text: "", class: "" };
          this.caseSpecimens = res;
        })
        .catch(() => {
          this.loadingText = {
            text: "Error loading specimens",
            class: "text-danger font-weight-bold"
          };
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.info-overlay-body {
  color: black;
  background-color: white;
  padding-left: 0.25em;
  padding-right: 0.5em;
  padding-top: 0.15em;
  padding-bottom: 0.15em;
  border: 1px solid lightgray;
}
.close-button:hover {
  cursor: pointer;
}
</style>
